export default __webpack_public_path__ + "0cf2d7f4b8369e5597e5ec2db00448cc.jpg";